<template>
  <div class="modalExprt">
    <div class="modalExportExcelPdf">
      <div style="border-radius:10px;padding:10px;" class="card">
        <img
          @click="closeModalExportExcelPdf()"
          src="@/assets/img/icons/close-icon.png"
          alt="close-icon"
          class="icon-close"
        />
        <p style="font-size:12px;">{{ $t("insight.exporter") }}</p>
        <hr />
        <Export
          :url_moderateur="modalExportExcelPdf.insightUrlModerateur"
          :id="modalExportExcelPdf.insightId"
          :created_at="modalExportExcelPdf.insightCreatedAt"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Export from "@/components/insight/PageAdmin/components/Export";
export default {
  name: "modalExportExcelPdf",
  components: {
    Export,
  },
  props: {
    modalExportExcelPdf: Object,
  },
  methods: {
    closeModalExportExcelPdf() {
      this.$store.commit("MODAL_EXPORTEXCELPDF", {
        sondageId: null,
        insightName: null,
        insightCreatedAt: null,
        insightUrlModerateur:null,
        activeModalExportExcelPdf: false,
      });
    },
  },
};
</script>
<style scoped>
.modalExprt {
  padding: 50px;
  overflow: hidden;
}
.modalExportExcelPdf {
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  text-align: center;
  font-size: 12px;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
</style>
